import React from 'react';
import {LibraryProvider} from './src/components/State';
import './src/styles/global.css';
import './static/chapter-navigation.css';
import './static/chapter-sidebar.js';
import './static/explore-ai.css';
export const wrapRootElement=({element}:{element:React.ReactNode})=><LibraryProvider>{element}</LibraryProvider>;

